
  // IMPORTANT: This file was generated by tools/build.js
  // If you edit it, your changes will be overwritten once dev server restarts
  export default {
  "CONFIG_ID": "adobe-auth:prod",
  "CUSTOM_APP_NAME": "Adobe Commerce Cloud",
  "CUSTOM_ASSETS_URL": "https://www.main-bvxea6i-q6jcg6bsdggvk.eu-3.platformsh.site/",
  "CUSTOM_BLACKFIRE_CARD_LANGUAGE": [
    "php",
    "python"
  ],
  "CUSTOM_BRANDING_MESSAGE": "Powered by Upsun",
  "CUSTOM_CLI_COMMAND": "magento-cloud",
  "CUSTOM_CONFIG_DIR_NAME": ".magento",
  "CUSTOM_CONSOLE_TITLE": false,
  "CUSTOM_CSP": "https://us.magento.cloud https://eu.magento.cloud https://us-2.magento.cloud https://us-3.magento.cloud https://eu-3.magento.cloud https://ap-3.magento.cloud https://eu-4.magento.cloud https://ap-4.magento.cloud https://eu-5.magento.cloud https://eu-6.magento.cloud https://us-5.magento.cloud https://az-westeurope-1.magento.cloud https://us-a1.magento.cloud https://us-a1.dev.magento.cloud",
  "CUSTOM_DEFAULT_BRANCH": "master",
  "CUSTOM_FEDERATED_AUTH_PROVIDERS": false,
  "CUSTOM_FOOTER_TEXT": false,
  "CUSTOM_LOGO_HEIGHT": 30,
  "CUSTOM_PROFILING_LANGUAGE": [
    "php",
    "python",
    "golang",
    "java",
    "node",
    "ruby",
    "rust"
  ],
  "CUSTOM_THEME": false,
  "CUSTOM_WINDOW_TITLE": "Magento Cloud",
  "CUSTOM_FULL_PAGE_REDIRECT": false,
  "CUSTOM_URL_BILLING": false,
  "CUSTOM_URL_CLI_DOWNLOAD": false,
  "CUSTOM_URL_DOCS": "https://experienceleague.adobe.com/docs/commerce-cloud-service/user-guide/overview.html",
  "CUSTOM_URL_DOCS_STATUS_CHECK": false,
  "CUSTOM_URL_PROJECT_CREATION": false,
  "CUSTOM_URL_SUBSCRIPTION_DELETE_REDIRECT": false,
  "CUSTOM_URL_SUBSCRIPTION_UPGRADE": false,
  "CUSTOM_URL_SUPPORT": "https://experienceleague.adobe.com/home#support",
  "CUSTOM_URL_VENDOR_CONSOLE": false,
  "CUSTOM_ERROR_SUPPORT_URL": false,
  "URL_ACCOUNTS": "https://accounts.magento.cloud",
  "URL_API_PROXY": "https://api.magento.cloud",
  "URL_AUTH": "https://auth.magento.cloud",
  "URL_GITHUB": "https://api.github.com",
  "URL_GITLAB": "https://gitlab.com",
  "URL_LOGOUT": "https://auth.magento.cloud/auth/logout",
  "URL_REDIRECT_AFTER_LOGIN": false,
  "URL_REDIRECT_AUTH_USER": "https://accounts.magento.cloud",
  "URL_STATUS_API": "https://status.upsun.com",
  "ID_API_CLIENT": "ui@magento",
  "ID_COOKIELAW": false,
  "ID_DRIFT_CHATBOT": false,
  "ID_PENDO": false,
  "ID_PENDO_AUTH": false,
  "ID_PLATFORM_TREE": false,
  "ID_SENTRY_DNS": "https://7682ebc48eef70826bdca7ac9f08b505@o38989.ingest.us.sentry.io/4508160398852096",
  "ID_SENTRY_ORGANIZATION": "platformsh",
  "ID_SENTRY_PROJECT": "console",
  "DISABLE_ALL_PROJECTS": false,
  "ENABLE_ACCOUNT_SECURITY_ROUTE": false,
  "ENABLE_ADD_DOMAIN_SUPPORT": true,
  "ENABLE_ADD_PROJECT_USER_PRICING_AGREEMENT": false,
  "ENABLE_ANNOUNCEMENTS": false,
  "ENABLE_AUTOSCALING": false,
  "ENABLE_BACKUPS": false,
  "ENABLE_BILLING": false,
  "ENABLE_BILLING_ACCOUNTS_MENU": false,
  "ENABLE_BLACKFIRE_CARD": false,
  "ENABLE_CARBON_EMISSIONS_DASHBOARD": false,
  "ENABLE_CHANGE_USERNAME_EMAIL": false,
  "ENABLE_COMMAND_MENU": false,
  "ENABLE_COMMAND_MENU_DOCS": false,
  "ENABLE_CONFIG_DIFFS": false,
  "ENABLE_CONNECTED_ACCOUNTS_ROUTE": false,
  "ENABLE_CONTAINERS_RELATIONSHIPS_DETAILS": false,
  "ENABLE_CONTAINERS_SERVICE_LINKS": false,
  "ENABLE_CONTINUOUS_PROFILING_SELLABLE": false,
  "ENABLE_CREATE_ORGANIZATION": false,
  "ENABLE_CREATE_PROJECT": false,
  "ENABLE_CRONS": false,
  "ENABLE_CUSTOM_BANNER_MESSAGE": false,
  "ENABLE_CUSTOM_LEFT_PANEL": false,
  "ENABLE_DEPLOYMENT_STRATEGIES": false,
  "ENABLE_DISCLAIMER_GENERAL_SUPPORT": false,
  "ENABLE_EDIT_PLAN": false,
  "ENABLE_ENVIRONMENT_DOMAINS": false,
  "ENABLE_ENVIRONMENT_SOCKET": true,
  "ENABLE_FIRST_PROJECT_INCENTIVE": false,
  "ENABLE_FREE_TRIAL_DIALOG": false,
  "ENABLE_GREEN_DISCOUNT": false,
  "ENABLE_HIPAA_COMPLIANCE": true,
  "ENABLE_HTTP_METRICS": false,
  "ENABLE_IMAGES_LIFECYCLE_MANAGEMENT": false,
  "ENABLE_INTERNAL_SERVICE_METRICS": false,
  "ENABLE_LOCAL_DEPLOYMENT_TARGET": true,
  "ENABLE_LOGS_EXPLORER": false,
  "ENABLE_MAINTENANCE_WINDOW": false,
  "ENABLE_MARKETING_CHECKBOX": false,
  "ENABLE_METRICS_EXPLORER": false,
  "ENABLE_MODAL_REDIRECTION_DOCS": false,
  "ENABLE_NOTIFICATION_SETTINGS": false,
  "ENABLE_OBJECT_STORAGE": false,
  "ENABLE_OBSERVABILITY_SUITE_INTEGRATIONS": false,
  "ENABLE_OBSERVABILITY_TABS": false,
  "ENABLE_OCI_DOCKER": false,
  "ENABLE_ORGANIZATION": false,
  "ENABLE_ORGANIZATION_PLANS_PERMISSION": true,
  "ENABLE_ORGANIZATION_TYPE_DISPLAY": false,
  "ENABLE_PLUGIN_APP": false,
  "ENABLE_PROFILING": false,
  "ENABLE_PROJECT_ACCESS_SELECT": false,
  "ENABLE_PROJECT_PROVISIONING_WIZARD": true,
  "ENABLE_PROJECT_SETUP_TIPS": false,
  "ENABLE_PROJECT_SETUP_WIZARD": false,
  "ENABLE_PROJECT_TRAFFIC_BLOCK": false,
  "ENABLE_PROVISIONING_CARD": true,
  "ENABLE_REACTIVATE_TRIAL": false,
  "ENABLE_REDUCED_WIZARD": false,
  "ENABLE_REDUX_DEVTOOLS": false,
  "ENABLE_REGISTRATION": false,
  "ENABLE_RESET_PROFILE_PASSWORD": false,
  "ENABLE_RESOURCE_ALLOCATION_PRICING": false,
  "ENABLE_RESOURCE_METRICS": false,
  "ENABLE_SECURITY_ENFORCEMENT_BANNER": true,
  "ENABLE_SENTRY": true,
  "ENABLE_SERVICE_TREE": false,
  "ENABLE_SERVICES_AUTOSCALING": false,
  "ENABLE_SETTINGS_RESOURCES": false,
  "ENABLE_SINGLE_STEP_SINGUP_FLOW": false,
  "ENABLE_SOURCE_REPOSITORY_TOOLTIP": true,
  "ENABLE_SSH_KEYS_API": false,
  "ENABLE_STAFF_TEST_MODE": false,
  "ENABLE_STRIPE": false,
  "ENABLE_SUPPORT_SELLABLE": false,
  "ENABLE_TERMS_AND_ACCEPTANCE_CHECKBOX": false,
  "ENABLE_TOTAL_RESOURCE_ALLOCATION_METRICS": false,
  "ENABLE_TRIAL_USAGE": false,
  "ENABLE_UNBRANDED_ILLUSTRATIONS": true,
  "ENABLE_USAGE_BASED_BILLING_PAGES": false,
  "ENABLE_VOUCHERS": false,
  "ENABLE_ZENDESK_LINKS": false,
  "VERSION_NUMBER": "3.3.122"
}